export default function RoleCreateController(
  $scope,
  $location,
  $state,
  $filter,
  usersService,
  RoleService,
  FeatureService,
  gettextCatalog,
) {
  'ngInject';

  $scope.roleName = '';
  $scope.description = '';
  $scope.filteredDataPoints = [];
  $scope.dataPointsByPage = [];
  $scope.datapointsDenied = [];
  $scope.useSecurityGroups = true;
  $scope.search = {
    previousQuery: '',
    query: '',
    text: '',
  };
  $scope.errorText = '';
  $scope.errorFlag = false;
  $scope.onLoadErrorText = '';
  $scope.onLoadErrorFlag = false;
  $scope.setAll = {};
  $scope.loading = true;
  $scope.datapointsSelectedCount = 0;

  $scope.features = [];
  $scope.sortedPermissions = [];

  $scope.getAllPermissions = function () {
    FeatureService.getFeatures().then(
      function (response) {
        const currentUserFeatures = usersService.currentUser().permissions;
        //set disabled based on user permission
        const features = response.data.map((f) => ({
          ...f,
          disabled: !currentUserFeatures.includes(f.path),
        }));
        $scope.hasDisabledFeatures = features.filter((f) => f.disabled).length > 0;

        $scope.features = features;
        $scope.sortedPermissions = features;
      },
      function (error) {
        let errorMsg = gettextCatalog.getString('An error occurred getting role data');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorText = errorMsg;
        $scope.errorFlag = true;
        $scope.sending = false;
      },
    );
  };

  $scope.getAllPermissions();

  $scope.getLeftPermissionPadding = function (permission) {
    if (!permission.path) return 0;

    return $scope.countPeriods(permission.path) * 50;
  };

  $scope.countPeriods = function (input) {
    let result = 0;

    for (let i = 0; i < input.length; i++) {
      if (input[i] == '.') {
        result++;
      }
    }
    return result;
  }; //countPeriods

  $scope.selectAllPermissions = function (flag) {
    for (let i = 0; i < $scope.sortedPermissions.length; i++) {
      $scope.sortedPermissions[i].checked = flag;
    }

    window.dataLayer.push({
      event: flag ? 'rolePermissionAllSelected' : 'rolePermissionAllDeselected',
    });
  };

  $scope.checkParent = function (path, flag) {
    let name = path.substr(0, path.indexOf('.'));

    if (flag && name.length > 0) {
      let childPath = '';

      if ($scope.countPeriods(path) > 1) {
        childPath = path.substr(0, path.lastIndexOf('.'));
      }

      for (var i = 0; i < $scope.sortedPermissions.length; i++) {
        if (
          $scope.sortedPermissions[i].path === name ||
          $scope.sortedPermissions[i].path == childPath
        ) {
          $scope.sortedPermissions[i].checked = flag;
        }
      }
    }
    //if parent is unchecked, uncheck all the children of the parent
    else if (name.length === 0 && !flag) {
      for (var i = 0; i < $scope.sortedPermissions.length; i++) {
        let childName = $scope.sortedPermissions[i].path.substr(
          0,
          $scope.sortedPermissions[i].path.indexOf('.'),
        );
        if (path === childName) {
          $scope.sortedPermissions[i].checked = flag;
        }
      }
    } else if (!flag) {
      //check to see if path has children
      for (var i = 0; i < $scope.sortedPermissions.length; i++) {
        if ($scope.sortedPermissions[i].path.indexOf(path) > -1) {
          $scope.sortedPermissions[i].checked = flag;
        }
      }
    }
    window.dataLayer.push({
      event: 'rolePermissionChanged',
      data: {
        permission: path,
        checked: flag,
      },
    });
  }; //checkParent

  //Sorting
  $scope.predicate1 = 'description';
  $scope.reverse1 = true;
  let orderBy = $filter('orderBy');

  //Sort filteredDataPoints
  $scope.orderDataPoints = function (predicate1) {
    if (predicate1 === $scope.predicate1) {
      $scope.reverse1 = !$scope.reverse1;
    } else {
      $scope.reverse1 = false;
    }
    $scope.predicate1 = predicate1;
    GTM_DatapointChanges('roleDatapointsOrderChanged');
  };

  //Pagination
  $scope.current = {
    page: 1,
    policyPage: 1,
  };
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = function (initialLoad) {
    if (typeof initialLoad === 'undefined' && $scope.search.previousQuery === $scope.search.query)
      return;
    $scope.filteredDataPoints = $filter('filter')($scope.datapoints, $scope.search.query);
    $scope.search.previousQuery = $scope.search.query;
    GTM_DatapointChanges(initialLoad ? 'roleDatapointsLoaded' : 'roleDatapointsFiltered');
  };

  $scope.createButtonPressed = function () {
    $scope.errorFlag = false;
    if (
      !($scope.roleName.length > 0 && !$scope.nameExists()) ||
      $scope.postingChange ||
      $scope.roleForm.$error.maxlength
    ) {
      return;
    }
    if ($scope.roleName || $scope.roleName.length === 0) {
      $scope.newRole = {
        name: $scope.roleName,
        description: $scope.description,
        featureList: [],
        dataPointsDenied: $scope.datapointsDenied,
        useSecurityGroups: $scope.useSecurityGroups,
      };

      //loop through the sort permissions to find the checked permissions and push them into the PUT object
      for (let i = 0; i < $scope.sortedPermissions.length; i++) {
        if ($scope.sortedPermissions[i].checked) {
          $scope.newRole.featureList.push($scope.sortedPermissions[i]);
        }
      } //out for

      $scope.postingChange = true;
      RoleService.createRole($scope.newRole).then(
        function (response) {
          $scope.postingChange = false;
          $state.go('admin.userroledetails', {
            roleId: response.data.id,
          });
        },
        function (error) {
          let errorMsg = gettextCatalog.getString('An error occurred while creating the role');
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg =
                error.data.message +
                ' ' +
                (error.status.toString() + ' - ' + error.statusText.toString());
            } else {
              errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString('. Please try again later.');
          }
          $scope.errorText = errorMsg;
          $scope.errorFlag = true;
          $scope.postingChange = false;
        },
      );
    }
  };

  let getExistingNames = function () {
    RoleService.getRoles().then(
      function onSuccess(response) {
        $scope.existingNames = [];
        for (let i = 0; i < response.data.length; i++) {
          $scope.existingNames.push(response.data[i].name);
        }
        if ($scope.datapoints && $scope.rolePolicies) {
          $scope.loading = false;
        }
      },
      function onError(error) {
        let errorMsg = gettextCatalog.getString('An error occurred');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        if ($scope.loading) {
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
          $scope.loading = false;
        }
      },
    );
  };

  let getRoleDatapoints = function () {
    usersService.getDatapoints().then(
      function (response) {
        $scope.datapoints = response.data;

        angular.forEach($scope.datapoints, function (obj) {
          obj['checkedDatapoint'] = true;
        });

        $scope.datapointsSelectedCount = $scope.datapoints.length;

        $scope.originalDatapoints = angular.copy($scope.datapoints);
        $scope.loading = false;
        $scope.applyFilter(true);
        if ($scope.existingNames && $scope.rolePolicies) {
          $scope.loading = false;
        }
      },
      function (error) {
        let errorMsg = 'An error occurred';
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        if ($scope.loading) {
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
          $scope.loading = false;
        }
      },
    );
  };

  $scope.datapointSelected = function (id) {
    for (let i = 0; i < $scope.datapointsDenied.length; i++) {
      if ($scope.datapointsDenied[i] === id) {
        $scope.datapointsDenied.splice(i, 1);
        $scope.datapointsSelectedCount++;
        GTM_DatapointChanges('roleDatapointSelected');
        return;
      }
    }
    $scope.datapointsDenied.push(id);
    $scope.datapointsSelectedCount--;
    GTM_DatapointChanges('roleDatapointDeselected');
  };

  $scope.nameExists = function () {
    if (!$scope.roleName) {
      return false;
    }
    for (let i = 0; i < $scope.existingNames.length; i++) {
      if ($scope.roleName.toLowerCase() === $scope.existingNames[i].toLowerCase()) {
        return true;
      }
    }
    return false;
  };

  getExistingNames();
  getRoleDatapoints();

  $scope.checkAllDatapoints = function () {
    $scope.datapointsDenied = [];

    for (let i = 0; i < $scope.datapoints.length; i++) {
      $scope.datapoints[i].checkedDatapoint = $scope.setAll.datapoints;

      if (!$scope.datapoints[i].checkedDatapoint) {
        $scope.datapointsDenied.push($scope.datapoints[i].id);
      }
    }

    if ($scope.setAll.datapoints) {
      $scope.datapointsSelectedCount = $scope.datapoints.length;
    } else $scope.datapointsSelectedCount = 0;

    GTM_DatapointChanges(
      $scope.setAll.datapoints ? 'roleDatapointsAllSelected' : 'roleDatapointsAllDeselected',
    );
  };

  $scope.backToRoles = function () {
    $location.path('/admin/roles');
  };

  $scope.nameChanged = function () {
    window.dataLayer.push({
      event: 'roleNameChanged',
    });
  };

  $scope.visibilityChanged = function () {
    window.dataLayer.push({
      event: 'roleVisibilityChanged',
      data: {
        assetsVisible: $scope.useSecurityGroups,
      },
    });
  };

  $scope.descriptionChanged = function () {
    window.dataLayer.push({
      event: 'roleDescriptionChanged',
    });
  };

  $scope.pageChanged = function () {
    GTM_DatapointChanges('roleDatapointsPageChanged');
  };

  function GTM_DatapointChanges(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.datapoints.length,
        totalFiltered: $scope.filteredDataPoints.length,
        totalSelected: $scope.datapointsSelectedCount,
        sortDirection: $scope.reverse1 ? 'descending' : 'ascending',
        pageNumber: $scope.current.page,
      },
    });
  }
}
